module.exports = __webpack_public_path__ + "img/item6.c414f94d.png";